import { withAuthentication } from 'Actions/auth';

const requested = (type, url) => {
    return {
        type: `REQUEST_${type.toUpperCase()}`,
        url: url.replace(/.*\/\/[^/]*/, '')
    };
};

const received = (type, url, method, params, data, { responseHeaders } = {}) => {
    const response = {
        data,
        url: url.replace(/.*\/\/[^/]*/, ''),
        params,
        responseHeaders
    };

    switch (method.toLowerCase()) {
        case 'get':
        case 'head':
            response.type = `RECEIVE_${type.toUpperCase()}`;
            break;
        default:
            response.type = `RESPONSE_${method.toUpperCase()}_${type.toUpperCase()}`;
            break;
    }
    return response;
};

const receivedWithError = (type, url, method, params, data, { statusCode } = {}) => {
    const response = {
        data,
        url: url.replace(/.*\/\/[^/]*/, ''),
        params,
        statusCode
    };

    switch (method.toLowerCase()) {
        case 'get':
        case 'head':
            response.type = `ERROR_${type.toUpperCase()}`;
            break;
        default:
            response.type = `ERROR_${method.toUpperCase()}_${type.toUpperCase()}`;
            break;
    }
    return response;
};

const getPathRewriteUrl = (path, config) => {
    const apiGatewayReWrite = config?.api?.pathRewrite || {};
    const findPathInGateway = Object.keys(apiGatewayReWrite).find(key => path.includes(key));

    if (findPathInGateway) {
        return path.replace(findPathInGateway, apiGatewayReWrite[findPathInGateway]);
    }
    return path;
};

const request = (url, method, params = {}, headers = {}, type, opts = {}) => {
    const { config } = opts;
    let targetUrl = url;

    if (config && config.apiGatewayHost && config.shouldByPassProxy && url) {
        const pathRewrittenUrl = getPathRewriteUrl(url, config);

        targetUrl = `${config.apiGatewayHost}${pathRewrittenUrl}`;
    }
    return dispatch => {
        return dispatch(withAuthentication(dispatch => {
            return dispatch({
                type: 'API',
                actions: {
                    requested,
                    received,
                    receivedWithError
                },
                payload: {
                    url,
                    method,
                    params,
                    headers,
                    type,
                    targetUrl
                }
            });
        }));
    };
};

const get = (url, type, params = {}, headers = {}, opts) =>
    request(url, 'GET', params, headers, type, opts);
const post = (url, type, params = {}, headers = {}, opts) =>
    request(url, 'POST', params, headers, type, opts);
const del = (url, type, params = {}, headers = {}) =>
    request(url, 'DELETE', params, headers, type);
const put = (url, type, params = {}, headers = {}) =>
    request(url, 'PUT', params, headers, type);
const head = (url, type, params = {}, headers = {}) =>
    request(url, 'HEAD', params, headers, type);
const patch = (url, type, params = {}, headers = {}) =>
    request(url, 'PATCH', params, headers, type);

export { request, get, post, put, del, head, patch };
